module.exports = __webpack_public_path__ + "img/pantalla-1-2.2deebd91.png";